import React from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord } from 'react-icons/fa';

const FinalCTA = () => {
  return (
    <section aria-label="Get started with Katbot" className="relative py-10 md:py-14 overflow-hidden w-full">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-900/30 via-purple-900/30 to-cyan-900/30" />

      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-white">
          Ready to Trade Smarter?
        </h2>
        <p className="text-gray-300 mt-2">
          Join the community for research, releases, and integration tips.
        </p>
        <p className="text-gray-400 mt-2 text-sm">
          Building your own trading platform?{' '}
          <Link to="/licensing" className="text-cyan-300 hover:text-cyan-200 underline">
            See licensing &rarr;
          </Link>
        </p>
        <div className="mt-5 flex flex-wrap justify-center gap-3">
          <a
            href="https://discord.gg/asTcxUTzRv"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-white/20 text-white px-6 py-2.5 rounded-xl font-semibold hover:border-white/40 hover:bg-white/5 transition-all duration-200 no-underline"
          >
            <FaDiscord className="text-lg" />
            Join Discord
          </a>
          <Link
            to="/licensing"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-6 py-2.5 rounded-xl font-semibold hover:from-cyan-400 hover:to-blue-500 transition-all duration-200 no-underline"
          >
            License the Platform
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
